import { useCallback } from 'react';
import { ACCOUNT_ID } from 'hooks';
import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';
import { PERSISTENCE_TYPE } from 'modules/taboola-common-frontend-modules/storage';
import { chatSessionIdValueStore } from '../utils/chatSessionIdValueStore';

export const CHAT_AGENT_SESSION_ID_PARAM_NAME = 'chat-agent-session-id';

const useChatAgentSessionIdParam = queryParamHookFactory(CHAT_AGENT_SESSION_ID_PARAM_NAME, {
    persist: PERSISTENCE_TYPE.MEMORY,
    dependencies: {
        queryParams: [ACCOUNT_ID],
    },
});

export const useChatAgentSessionId = () => {
    const [sessionId, setSessionId, unsetSessionId] = useChatAgentSessionIdParam();
    chatSessionIdValueStore.setValue(sessionId);

    const setSessionIdWrapper = useCallback(
        sessionIdValue => {
            chatSessionIdValueStore.setValue(sessionIdValue);
            setSessionId(sessionIdValue);
        },
        [setSessionId]
    );
    const unsetSessionIdWrapper = useCallback(() => {
        chatSessionIdValueStore.setValue();
        unsetSessionId();
    }, [unsetSessionId]);
    return [sessionId, setSessionIdWrapper, unsetSessionIdWrapper];
};
